import React from "react";
import SupportLayout from "../support/SupportLayout";
import SupportOfficerHomeContent from "./components/SupportOfficerHomeContent";

const SupportOfficerHome = ({ userRole = "SO" }) => {
  return (
    <SupportLayout userRole="SO">
      <SupportOfficerHomeContent userRole={userRole} useOwnLayout={true} />
    </SupportLayout>
  );
};

export default SupportOfficerHome;
